/**
 * FT6-U14 GL report routes (FSD 2.2.1.11): the journal register, manual
 * journal analysis and the cash-flow statement. Exported for INT to spread into
 * the router; this file edits no root route table.
 */

import type { RouteRecordRaw } from 'vue-router'

import { GL_PERMISSIONS } from '@/modules/gl/permissions'

export const GL_FT6_REPORT_ROUTES: RouteRecordRaw[] = [
  {
    path: '/gl/reports/journal-register',
    name: 'gl-journal-register',
    component: () => import('@/modules/gl/reports/journal-register/JournalRegisterView.vue'),
    meta: {
      titleKey: 'gl.ft6.routeTitles.journalRegister',
      // GET /journal-entries and /journal-entries/export both declare gl.journal.read.
      permission: GL_PERMISSIONS.journalRead,
    },
  },
  {
    path: '/gl/reports/manual-journals',
    name: 'gl-manual-journals',
    component: () => import('@/modules/gl/reports/manual-journals/ManualJournalsView.vue'),
    meta: {
      titleKey: 'gl.ft6.routeTitles.manualJournals',
      permission: GL_PERMISSIONS.reportRead,
    },
  },
  {
    path: '/gl/reports/cash-flow',
    name: 'gl-cash-flow',
    component: () => import('@/modules/gl/reports/cash-flow/CashFlowView.vue'),
    meta: {
      titleKey: 'gl.ft6.routeTitles.cashFlow',
      permission: GL_PERMISSIONS.reportRead,
    },
  },
]
